import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <main className="pt-32 container-apex">Loading…</main>;
  if (err || !post) return (
    <main className="pt-32 container-apex">
      <h1 className="heading-display text-4xl">Post not found.</h1>
      <Link to="/blog" className="mt-6 inline-flex items-center gap-2 text-[#16A34A]"><ArrowLeft size={16}/> Back to blog</Link>
    </main>
  );

  return (
    <main className="min-h-screen pt-28 pb-20" data-testid="blog-post-page">
      <article className="container-apex max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-[#16A34A]" data-testid="blog-back">
          <ArrowLeft size={14} /> All articles
        </Link>
        <div className="mt-8 flex gap-2 flex-wrap">
          {post.tags?.map((t) => (
            <span key={t} className="text-[10px] tracking-widest uppercase font-bold text-[#16A34A]">{t}</span>
          ))}
        </div>
        <h1 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">{post.title}</h1>
        <div className="mt-4 text-sm text-muted-foreground">{new Date(post.created_at).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })}</div>
        {post.cover_image && (
          <div className="mt-10 aspect-[16/9] overflow-hidden rounded-2xl border border-border">
            <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="mt-10 prose prose-lg max-w-none text-foreground/90 leading-relaxed">
          {post.content.split("\n").map((p, i) => (
            <p key={i} className="mb-6 text-lg leading-[1.8]">{p}</p>
          ))}
        </div>
      </article>
    </main>
  );
}
